// Bible data structure and utilities
export const BIBLE_BOOKS = {
  oldTestament: [
    { name: 'Genesis', abbreviation: 'Gen', chapters: 50 },
    { name: 'Exodus', abbreviation: 'Exod', chapters: 40 },
    { name: 'Leviticus', abbreviation: 'Lev', chapters: 27 },
    { name: 'Numbers', abbreviation: 'Num', chapters: 36 },
    { name: 'Deuteronomy', abbreviation: 'Deut', chapters: 34 },
    { name: 'Joshua', abbreviation: 'Josh', chapters: 24 },
    { name: 'Judges', abbreviation: 'Judg', chapters: 21 },
    { name: 'Ruth', abbreviation: 'Ruth', chapters: 4 },
    { name: '1 Samuel', abbreviation: '1 Sam', chapters: 31 },
    { name: '2 Samuel', abbreviation: '2 Sam', chapters: 24 },
    { name: '1 Kings', abbreviation: '1 Kgs', chapters: 22 },
    { name: '2 Kings', abbreviation: '2 Kgs', chapters: 25 },
    { name: '1 Chronicles', abbreviation: '1 Chr', chapters: 29 },
    { name: '2 Chronicles', abbreviation: '2 Chr', chapters: 36 },
    { name: 'Ezra', abbreviation: 'Ezra', chapters: 10 },
    { name: 'Nehemiah', abbreviation: 'Neh', chapters: 13 },
    { name: 'Esther', abbreviation: 'Esth', chapters: 10 },
    { name: 'Job', abbreviation: 'Job', chapters: 42 },
    { name: 'Psalm', abbreviation: 'Ps', chapters: 150 },
    { name: 'Proverbs', abbreviation: 'Prov', chapters: 31 },
    { name: 'Ecclesiastes', abbreviation: 'Eccl', chapters: 12 },
    { name: 'Song of Solomon', abbreviation: 'Song', chapters: 8 },
    { name: 'Isaiah', abbreviation: 'Isa', chapters: 66 },
    { name: 'Jeremiah', abbreviation: 'Jer', chapters: 52 },
    { name: 'Lamentations', abbreviation: 'Lam', chapters: 5 },
    { name: 'Ezekiel', abbreviation: 'Ezek', chapters: 48 },
    { name: 'Daniel', abbreviation: 'Dan', chapters: 12 },
    { name: 'Hosea', abbreviation: 'Hos', chapters: 14 },
    { name: 'Joel', abbreviation: 'Joel', chapters: 3 },
    { name: 'Amos', abbreviation: 'Amos', chapters: 9 },
    { name: 'Obadiah', abbreviation: 'Obad', chapters: 1 },
    { name: 'Jonah', abbreviation: 'Jonah', chapters: 4 },
    { name: 'Micah', abbreviation: 'Mic', chapters: 7 },
    { name: 'Nahum', abbreviation: 'Nah', chapters: 3 },
    { name: 'Habakkuk', abbreviation: 'Hab', chapters: 3 },
    { name: 'Zephaniah', abbreviation: 'Zeph', chapters: 3 },
    { name: 'Haggai', abbreviation: 'Hag', chapters: 2 },
    { name: 'Zechariah', abbreviation: 'Zech', chapters: 14 },
    { name: 'Malachi', abbreviation: 'Mal', chapters: 4 }
  ],
  newTestament: [
    { name: 'Matthew', abbreviation: 'Matt', chapters: 28 },
    { name: 'Mark', abbreviation: 'Mark', chapters: 16 },
    { name: 'Luke', abbreviation: 'Luke', chapters: 24 },
    { name: 'John', abbreviation: 'John', chapters: 21 },
    { name: 'Acts', abbreviation: 'Acts', chapters: 28 },
    { name: 'Romans', abbreviation: 'Rom', chapters: 16 },
    { name: '1 Corinthians', abbreviation: '1 Cor', chapters: 16 },
    { name: '2 Corinthians', abbreviation: '2 Cor', chapters: 13 },
    { name: 'Galatians', abbreviation: 'Gal', chapters: 6 },
    { name: 'Ephesians', abbreviation: 'Eph', chapters: 6 },
    { name: 'Philippians', abbreviation: 'Phil', chapters: 4 },
    { name: 'Colossians', abbreviation: 'Col', chapters: 4 },
    { name: '1 Thessalonians', abbreviation: '1 Thess', chapters: 5 },
    { name: '2 Thessalonians', abbreviation: '2 Thess', chapters: 3 },
    { name: '1 Timothy', abbreviation: '1 Tim', chapters: 6 },
    { name: '2 Timothy', abbreviation: '2 Tim', chapters: 4 },
    { name: 'Titus', abbreviation: 'Titus', chapters: 3 },
    { name: 'Philemon', abbreviation: 'Phlm', chapters: 1 },
    { name: 'Hebrews', abbreviation: 'Heb', chapters: 13 },
    { name: 'James', abbreviation: 'Jas', chapters: 5 },
    { name: '1 Peter', abbreviation: '1 Pet', chapters: 5 },
    { name: '2 Peter', abbreviation: '2 Pet', chapters: 3 },
    { name: '1 John', abbreviation: '1 Jn', chapters: 5 },
    { name: '2 John', abbreviation: '2 Jn', chapters: 1 },
    { name: '3 John', abbreviation: '3 Jn', chapters: 1 },
    { name: 'Jude', abbreviation: 'Jude', chapters: 1 },
    { name: 'Revelation', abbreviation: 'Rev', chapters: 22 }
  ]
};

export const BIBLE_TRANSLATIONS = [
  { code: 'KJV', name: 'King James Version', language: 'English' },
  { code: 'NIV', name: 'New International Version', language: 'English' },
  { code: 'ESV', name: 'English Standard Version', language: 'English' },
  { code: 'NKJV', name: 'New King James Version', language: 'English' },
  { code: 'NLT', name: 'New Living Translation', language: 'English' },
  { code: 'AMP', name: 'Amplified Bible', language: 'English' },
  { code: 'MSG', name: 'The Message', language: 'English' },
  { code: 'CSB', name: 'Christian Standard Bible', language: 'English' },
  { code: 'NASB', name: 'New American Standard Bible', language: 'English' }
];

// Sample verses for demonstration (in a real app, this would be much more comprehensive)
export const SAMPLE_VERSES = {
  'Gen.1.1': {
    text: 'In the beginning God created the heaven and the earth.',
    translation: 'KJV'
  },
  'John.3.16': {
    text: 'For God so loved the world, that he gave his only begotten Son, that whosoever believeth in him should not perish, but have everlasting life.',
    translation: 'KJV'
  },
  'Ps.23.1': {
    text: 'The LORD is my shepherd; I shall not want.',
    translation: 'KJV'
  },
  'Rom.8.28': {
    text: 'And we know that all things work together for good to them that love God, to them who are the called according to his purpose.',
    translation: 'KJV'
  },
  'Phil.4.13': {
    text: 'I can do all things through Christ which strengtheneth me.',
    translation: 'KJV'
  }
};

export const getAllBooks = () => {
  return [...BIBLE_BOOKS.oldTestament, ...BIBLE_BOOKS.newTestament];
};

export const getBookByName = (name) => {
  return getAllBooks().find(book => book.name === name);
};

export const getBookByAbbreviation = (abbrev) => {
  return getAllBooks().find(book => book.abbreviation === abbrev);
};

export const getChaptersForBook = (bookName) => {
  const book = getBookByName(bookName);
  return book ? Array.from({ length: book.chapters }, (_, i) => i + 1) : [];
};

export const formatReference = (book, chapter, verse = null) => {
  const bookData = getBookByName(book);
  const abbrev = bookData ? bookData.abbreviation : book;
  return verse ? `${abbrev} ${chapter}:${verse}` : `${abbrev} ${chapter}`;
};

export const parseReference = (reference) => {
  // Parse references like "John 3:16" or "Gen 1"
  const match = reference.match(/^(\w+(?:\s+\w+)?)\s+(\d+)(?::(\d+))?$/);
  if (!match) return null;

  const [, bookPart, chapter, verse] = match;
  const book = getBookByAbbreviation(bookPart) || getBookByName(bookPart);

  return {
    book: book ? book.name : bookPart,
    chapter: parseInt(chapter),
    verse: verse ? parseInt(verse) : null
  };
};

export const getVerse = (book, chapter, verse, translation = 'KJV') => {
  // In a real implementation, this would fetch from an API or local database
  // For now, return sample data
  const key = `${getBookByName(book)?.abbreviation || book}.${chapter}.${verse}`;
  return SAMPLE_VERSES[key] || null;
};

export const searchVerses = (query, translation = 'KJV') => {
  // Simple text search in sample verses
  // In a real app, this would search through the entire Bible text
  const results = [];
  Object.entries(SAMPLE_VERSES).forEach(([ref, data]) => {
    if (data.translation === translation && data.text.toLowerCase().includes(query.toLowerCase())) {
      const parsed = parseReference(ref.replace(/\./g, ' '));
      if (parsed) {
        results.push({
          ...parsed,
          text: data.text,
          reference: ref
        });
      }
    }
  });
  return results;
};